<template>
    <div class="data_body">
        <div style="width: 100%; height: 100%">
            <div id="charts_canvas" class="echart" style="width: 100%; height: 100%; "></div>
        </div>
    </div>
</template>
  
<script>
export default {
    props: {
        courseNumberArray: {
            type: Array,
        },
    },
    data() {
        return {
            chartObj: null,
            ooption: {
                data: [],
            },
            option: {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        // Use axis to trigger tooltip
                        type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
                    }
                },
                legend: {
                    bottom: 10
                },
                grid: {
                    left: '5%',
                    right: '5%',
                    bottom: '5%',
                    top: '5%',
                    containLabel: true
                },
                xAxis: {
                    type: 'value'
                },
                yAxis:  {
                        type: 'category',
                        data: [
                            '一年级',
                            '二年级',
                            '三年级',
                            '四年级',
                            '五年级',
                            '六年级'
                        ],
                        axisLine: {
                            show: false //不显示横轴线
                        },
                        axisTick: {
                            alignWithLabel: true, //柱状图中心是否对齐刻度位置
                            show: false //不显示刻度
                        },
                        axisLabel: {
                            interval: 0,
                            formatter: function (value) {
                                var ret = "";//拼接加\n返回的类目项  
                                var maxLength = 3;//每项显示文字个数  
                                var valLength = value.length;//X轴类目项的文字个数  
                                var rowN = Math.ceil(valLength / maxLength); //类目项需要换行的行数  
                                if (rowN > 1)//如果类目项的文字大于5,  
                                {
                                    for (var i = 0; i < rowN; i++) {
                                        var temp = "";//每次截取的字符串  
                                        var start = i * maxLength;//开始截取的位置  
                                        var end = start + maxLength;//结束截取的位置  
                                        //这里也可以加一个是否是最后一行的判断，但是不加也没有影响，那就不加吧  
                                        temp = value.substring(start, end) + "\n";
                                        ret += temp; //凭借最终的字符串  
                                    }
                                    return ret;
                                }
                                else {
                                    return value;
                                }
                            }
                        }
                    },
                series: [
                    {
                        type: 'bar',
                        stack: 'total',
                        barWidth: 30,
                        // label: {
                        //     show: true
                        // },
                        emphasis: {
                            focus: 'series'
                        },
                        data: [86, 106, 67, 33, 29, 22]
                    }
                ]
            },
        };
    },
    methods: {
        setChart(option) {
            // 雷达图显示的标签
            let newPromise = new Promise((resolve) => {
                resolve();
            });
            //然后异步执行echarts的初始化函数
            newPromise.then(() => {
                const chartObj = this.$echarts.init(
                    //劳动课程
                    this.$el.querySelector("#charts_canvas")
                );
                // this.option.series[0].data = this.ooption.data.filter(item => item.value !== 0);

                // 初始化雷达图
                this.chartObj = chartObj;
                this.chartObj.setOption(this.option);
            });
        },
        setArray(array) {
            this.ooption = {
                data: [],
            }
            for (var i = 0; i < array.length; i++) {
                this.ooption.data.push({ value: array[i].course, name: array[i].name })
            }
            if (!this.chartObj) {
                this.setChart(this.ooption);
            } else {
                this.option.series[0].data = this.ooption.data;
                this.chartObj.setOption(this.option);
            }
            this.$forceUpdate();
        },
    },
    watch: {
        courseNumberArray: {
            immediate: true,
            deep: true,
            handler(newValue, oldValue) {
                this.setArray(newValue)
                this.$forceUpdate();
            },
        },
    },
    mounted() {
        this.setArray(this.courseNumberArray)
        var _this = this;
        window.addEventListener("resize", () => {
            if (_this.chartObj) {
                _this.chartObj.resize();
            }
        });
    },
};
</script>
  
<style scoped>
.data_body {
    height: 100%;
    /* display: flex; */
    position: relative;
    border-radius: 5px;
    /* border: 1px solid #eee; */
    margin: 0 auto;
    box-sizing: border-box;
    padding: 0;
    width: 95%;
    background: #fff;
}
</style>
  


// WEBPACK FOOTER //
// src/components/pages/dataBoardSies/school/courseInfo/index.vue